module.exports = __webpack_public_path__ + "img/2.b39740a3.png";